import axios from "axios";
import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import DequipoRehabilitacionCardiaca from "../../EliminaEquipos/DequipoRehabilitacionCardiaca";
import CreaEquipoRehabilitacionC from "./CreaEquipos/CreaEquipoRehabilitacionC";

function EquipoRehabilitacionCardiaca({ idSolicitud }) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  // 🔹 Obtener listado
  const fetchList = async () => {
    try {
      const res = await axios({
        method: "get",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: `https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoRehabilitacionCardiacaPorSolicitudId?SolicitudId=${idSolicitud}`,
      });

      setList(res.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  // 🔹 Cargar cuando cambia la solicitud
  useEffect(() => {
    if (idSolicitud) {
      fetchList();
    }
  }, [idSolicitud]);

  // 🔹 Eliminar sin recargar
  const handleDelete = (id) => {
    setList((prev) => prev.filter((item) => item.id !== id));
  };

  const nombreRuta =
    window.location.href.split("/")[
      window.location.href.split("/").indexOf("#") + 1
    ];

  return (
    <div className="container text-center">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            3.2. Nombre y cargo del líder responsable de integrar los equipos de
            apoyo de Terapias, Rehabilitación Cardíaca, Pulmonar, Visual,
            Psicología y Salud Mental
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            nombreRuta === "ProcesoAutoevaluacion" && (
              <CreaEquipoRehabilitacionC
                idSolicitud={idSolicitud}
                onCreated={fetchList}
              />
            )}

          <div className="table-responsive mt-3">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Servicio</th>
                  <th>Cargo</th>
                  <th>Líder</th>
                  {cookies.get("tipo_Usuario") == 2 &&
                    nombreRuta === "ProcesoAutoevaluacion" && <th>Eliminar</th>}
                </tr>
              </thead>

              <tbody>
                {list.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-muted">
                      No hay registros
                    </td>
                  </tr>
                ) : (
                  list.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nombre}</td>
                      <td>{item.servicio}</td>
                      <td>{item.cargo}</td>
                      <td>{item.lider}</td>

                      {cookies.get("tipo_Usuario") == 2 &&
                        nombreRuta === "ProcesoAutoevaluacion" && (
                          <td>
                            <DequipoRehabilitacionCardiaca
                              id={item.id}
                              onDelete={handleDelete}
                            />
                          </td>
                        )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EquipoRehabilitacionCardiaca;
